// Module
var code = "<p>The Suitable Fishing Area service is run as a scheduled task. </p> <p>Results can be visualized via the &#39;HSI-whiting&#39; layer: <strong>&#39;Data viewer&#39; → &#39;Select a layer for visualization&#39;</strong> </p> ";
// Exports
module.exports = code;